/**
 * Which Hasura roles may sign in to the admin portal.
 *
 * Mirrors admin v4 (hopdrive/admin-portal, `DataProvider.getFirebaseIdToken`), which only
 * kept a session whose `x-hasura-default-role` claim is `admin` and signed everyone else
 * out. The default role is what matters: this app never sends an `x-hasura-role` header,
 * so every GraphQL request runs as the default role, and the admin queries assume the
 * `admin` permission set. A dealer-family user (dealer, dealer-admin, dealer-super-admin)
 * belongs in the dealer portal; here their queries would fail on missing columns.
 */
export const ADMIN_PORTAL_ROLES: readonly string[] = ['admin'];

export type PermittedRoleClaims = {
  'x-hasura-default-role'?: string;
};

export const isPermittedRole = (defaultRole?: string | null): boolean =>
  !!defaultRole && ADMIN_PORTAL_ROLES.includes(defaultRole);

/** True when the signed-in user's default role may use the admin portal. */
export const checkForPermittedRole = (user?: { claims?: PermittedRoleClaims } | null): boolean =>
  isPermittedRole(user?.claims?.['x-hasura-default-role']);
